// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2EEQ0","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1O3WA"};